var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconclusterOffActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.211,
    height: 13.831,
    viewBox: "0 0 12.211 13.831",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon_cluster_off-active",
    "data-name": "icon cluster_off-active",
    d: "M8.5,13.831A2.965,2.965,0,0,1,6.854,8.4L5.827,7.381v.007A2.913,2.913,0,1,1,2.9,4.474L0,1.6.824.781,1,.951l-.146.164L12.211,12.385l-.67.665-.561-.556A2.961,2.961,0,0,1,8.5,13.831Zm2.21-6.238a1.474,1.474,0,1,1,1.474-1.475A1.476,1.476,0,0,1,10.712,7.593ZM7.3,5.362h0l-3-2.976a2.691,2.691,0,1,1,3,2.977Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconclusterOffActive);
export default __webpack_public_path__ + "static/media/icon cluster_off-active.1d76956b.svg";
export { ForwardRef as ReactComponent };